(function () {
  function esc(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
    });
  }

  function categoryUrlFromCatalog(catalogUrl) {
    if (!catalogUrl) return '';
    return catalogUrl.replace('blog-catalog-data-', 'blog-categories-');
  }

  function injectStyles() {
    if (document.getElementById('blog-category-sidebar-styles')) return;
    var style = document.createElement('style');
    style.id = 'blog-category-sidebar-styles';
    style.textContent = [
      '.bc-category-group{border-top:1px solid var(--bc-border-light,#e8dedd);padding-top:8px;margin-top:6px;}',
      '.bc-category-heading{display:flex;align-items:center;justify-content:space-between;width:100%;border:none;background:none;color:var(--bc-text,#333);cursor:pointer;font-family:Poppins,var(--font-body-family),sans-serif;font-size:12px;font-weight:600;padding:7px 0;text-align:left;}',
      '.bc-category-count{color:var(--bc-text-muted,#888);font-size:11px;font-weight:400;}',
      '.bc-category-items{display:none;flex-direction:column;gap:2px;padding-bottom:4px;}',
      '.bc-category-group.open .bc-category-items{display:flex;}',
      '.bc-categories-section{display:flex;flex-direction:column;gap:4px;}'
    ].join('');
    document.head.appendChild(style);
  }

  function renderCategories(section, data) {
    if (!data || !Array.isArray(data.categories)) return;
    var sidebar = section.querySelector('.bc-sidebar');
    if (!sidebar || sidebar.querySelector('.bc-categories-section')) return;

    var tagSection = sidebar.querySelector('.bc-tags-section');
    if (tagSection) tagSection.style.display = 'none';

    var box = document.createElement('div');
    box.className = 'bc-categories-section';
    box.innerHTML = '<div class="bc-tags-label" style="margin-bottom:6px;">Categories</div>' +
      data.categories.map(function (category, index) {
        var open = index === 0 ? ' open' : '';
        var items = (category.articles || []).map(function (article) {
          return '<a href="' + esc(article.url) + '" class="bc-article-link"><span class="bc-article-title">' + esc(article.title) + '</span></a>';
        }).join('');
        return '<div class="bc-category-group' + open + '">' +
          '<button type="button" class="bc-category-heading"><span>' + esc(category.title) + '</span><span class="bc-category-count">' + (category.articles || []).length + '</span></button>' +
          '<div class="bc-category-items">' + items + '</div>' +
        '</div>';
      }).join('');

    if (tagSection) tagSection.insertAdjacentElement('afterend', box);
    else sidebar.appendChild(box);

    box.querySelectorAll('.bc-category-heading').forEach(function (button) {
      button.addEventListener('click', function () {
        button.parentNode.classList.toggle('open');
      });
    });
  }

  function init() {
    injectStyles();
    document.querySelectorAll('.blog-catalog').forEach(function (section) {
      var catalogUrl = section.getAttribute('data-blog-catalog-url');
      var categoriesUrl = section.getAttribute('data-blog-categories-url') || categoryUrlFromCatalog(catalogUrl);
      if (!categoriesUrl) return;
      fetch(categoriesUrl)
        .then(function (resp) { return resp.ok ? resp.json() : null; })
        .then(function (data) { renderCategories(section, data); })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
